var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 27.715,
    viewBox: "0 0 34 27.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "referral",
    transform: "translate(-176.752 -238.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M557.728,531.38l-7.618-3.188.751,2.973s-9.33,1.62-8.167,10.094c1.248-5.671,9.029-6.657,9.029-6.657l.751,2.973,5.253-6.194Z",
    transform: "translate(-347.316 -274.606)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M602.661,551.34l-6.592-2.764.647,2.574s-8.069,1.4-7.063,8.729c1.078-4.9,7.807-5.756,7.807-5.756l.647,2.574Z",
    transform: "translate(-391.909 -293.959)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M274.979,632.146c-.078-.869.9-1.829,1.731-2.208s1.313-.144,1.156.176-.836.085-1.627,1.013c-.451.529-.575,1.091-.791,1.2A.31.31,0,0,1,274.979,632.146Z",
    transform: "translate(-93.248 -371.015)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M193.465,264.541H178.771a10.838,10.838,0,0,1,18.431-6.7,7.5,7.5,0,0,1,1.98-.764l-.157-.176a12.823,12.823,0,0,0-5.214-3.456,7.877,7.877,0,1,0-8.507,0,12.812,12.812,0,0,0-8.552,12.08.979.979,0,0,0,.287.693.991.991,0,0,0,.693.287h16.085a7.22,7.22,0,0,1-.353-1.967Zm-9.813-17.725a5.915,5.915,0,1,1,5.913,5.906,5.915,5.915,0,0,1-5.913-5.906Z",
    transform: "translate(0)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M250.731,567.854a10.13,10.13,0,0,0-16.954,5.749H247.6a7.335,7.335,0,0,1,3.136-5.749Z",
    transform: "translate(-54.137 -309.637)",
    fill: "#174a84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M274.979,632.146c-.078-.869.9-1.829,1.731-2.208s1.313-.144,1.156.176-.836.085-1.627,1.013c-.451.529-.575,1.091-.791,1.2A.31.31,0,0,1,274.979,632.146Z",
    transform: "translate(-93.248 -371.015)",
    fill: "#174a84"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.931d366c4bf07f901478243f1f9586f9.svg";
export { ForwardRef as ReactComponent };